export const registerOpportunityStagePath = (Alpine) => {
    Alpine.data(
        "opportunityStagePath",
        ({
            pendingStage = null,
            prompts = {},
            details = {},
            preventSubmit = false,
        } = {}) => ({
            pendingStage,
            prompts,
            details,
            preventSubmit,
            promptText() {
                return this.prompts[this.pendingStage] ?? "";
            },
            detailText() {
                return this.details[this.pendingStage] ?? "";
            },
            init() {
                if (this.pendingStage) {
                    this.$nextTick(() => this.$refs.confirmButton?.focus());
                }
            },
            select(stage) {
                this.pendingStage = stage;
                this.$nextTick(() => this.$refs.confirmButton?.focus());
            },
            cancel() {
                this.pendingStage = null;
            },
            confirm(event) {
                if (this.preventSubmit) {
                    event.preventDefault();
                    this.cancel();
                }
            },
        }),
    );
};
